<!-- Global Alert Overlay -->
<div
  class="global-alert-overlay"
  [class.visible]="isVisible()"
  (click)="onBackdropClick($event)"
  [attr.data-theme]="alertType()"
  >
  <div class="global-alert-container" [class.animate-in]="isVisible()">
    <!-- Alert Content -->
    <div class="alert-content" [attr.data-type]="alertType()">
      <!-- Header with Icon and Title -->
      <div class="alert-header">
        @if (hasTitle()) {
          <h3 class="alert-title">
            {{ currentAlert()?.title }}
          </h3>
        }
      </div>

      <!-- Message Content -->
      <div class="alert-body">
        <!-- HTML Message (when provided) -->
        @if (currentAlert()?.htmlMessage) {
          <div
            class="alert-message-html"
            [innerHTML]="currentAlert()?.htmlMessage"
          ></div>
        } @else {
          <p class="alert-message">
            {{ currentAlert()?.message }}
          </p>
        }

        <!-- Plain Text Message (fallback) -->
      </div>

      <!-- Action Buttons -->
      <div class="alert-actions">
        @if (showCancel()) {
          <button
            mat-button
            class="cancel-button"
            (click)="onCancel()"
            >
            {{ currentAlert()?.cancelText || "Cancel" }}
          </button>
        }
        <button
          mat-raised-button
          class="confirm-button"
          [attr.data-type]="alertType()"
          (click)="onConfirm()"
          >
          {{ currentAlert()?.confirmText || "OK" }}
        </button>
      </div>
    </div>
  </div>
</div>
